import React from 'react'
import Hero from '../components/Hero'
import TextSection from '../components/TextSection'
import { textsection_fiveexperts } from '../data/TextsectionData'
import TextwithImage from '../components/TextwithImage'
import { ExpertPage } from '../data/TextwithimageData'
import EnquiryForm from '../components/EnquiryForm'
import { useNavigate } from 'react-router-dom'
import TimeZoneDisplay from '../components/TimeZoneDisplay'

const Experts = () => {
  const navigate = useNavigate();
  return (
    <>
    <Hero
      title="Your Next Step Starts Here!"
      description="Looking for solutions? Fill out the form below, and our experts will connect with you shortly."
      buttonText=""
      customClass="ExpertBanner"
      imageSrc=""
      squareColor="expertsquare-bg-color"
      onButtonClick={() => navigate('meet-the-experts')}
    />
    
    <EnquiryForm/>



    <TextSection  data={textsection_fiveexperts} withSpan={false}/>
    {ExpertPage.map((expert, index) => (
    <TextwithImage key={index} data={expert} />
    ))}

    </>
  )
}

export default Experts